import { render, staticRenderFns } from "./ManageStaffScreen.vue?vue&type=template&id=fde2afb0&scoped=true&"
import script from "./ManageStaffScreen.vue?vue&type=script&lang=js&"
export * from "./ManageStaffScreen.vue?vue&type=script&lang=js&"
import style0 from "./ManageStaffScreen.vue?vue&type=style&index=0&id=fde2afb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde2afb0",
  null
  
)

component.options.__file = "ManageStaffScreen.vue"
export default component.exports